import React, { useState, useEffect } from "react";
import { Switch, Route } from "react-router-dom";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Stats } from "./components/stats";
import { Features } from "./components/features";
import { About } from "./components/about";
import { Services } from "./components/services";
import { Products } from "./components/products";
import { Technologies } from "./components/technologies";
import { Cases } from "./components/cases";
import { Contact } from "./components/contact";
import { PrivacyPolicy } from "./components/privacy-policy";
import { TermsOfService } from "./components/terms-of-service";
import { ArsenalHub } from "./components/arsenalhub";
import { ArsenalHubPrivacyPolicy } from "./components/arsenalhub-privacy-policy";
import { ArsenalHubTermsOfUse } from "./components/arsenalhub-terms-of-use";
import JsonData from "./data/data.json";
import ArsenalHubData from "./data/arsenalhub.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const HomePage = ({ data }) => (
  <>
    <Navigation />
    <Header data={data.Header} />
    <Stats />
    <Features data={data.Features} />
    <About data={data.About} />
    <Services data={data.Services} />
    <Products data={data.Products} />
    <Technologies data={data.technologies} />
    <Cases data={data.cases} />
    <Contact data={data.Contact} />
  </>
);

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  const [arsenalHubPageData, setArsenalHubPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
    setArsenalHubPageData(ArsenalHubData);
  }, []);

  return (
    <Switch>
      <Route path="/arsenalhub/privacy-policy">
        <ArsenalHubPrivacyPolicy />
      </Route>
      <Route path="/arsenalhub/terms-of-use">
        <ArsenalHubTermsOfUse />
      </Route>
      <Route path="/arsenalhub">
        <ArsenalHub data={arsenalHubPageData} />
      </Route>
      <Route path="/politica-privacidade">
        <PrivacyPolicy />
      </Route>
      <Route path="/termos-de-uso">
        <TermsOfService />
      </Route>
      <Route path="/">
        <HomePage data={landingPageData} />
      </Route>
    </Switch>
  );
};

export default App;
